





































import { SfImage, SfLink } from '~/components';
import { defineComponent, useContext, useRouter } from '@nuxtjs/composition-api';
import promoGetters from "~/modules/promo/getters/promoGetters";

export default defineComponent({
  name: "PromoItem",
  components: {
    SfImage,
    SfLink,
  },
  props: {
    promo: {
      type: Object,
      default: () => {}
    },
    isPromoListing: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { app: { localePath } } = useContext();
    const router = useRouter();

    const isPromoLabel = !!props.promo.label

    const handleClick = async (label, promoUrl) => {

      if (!isPromoLabel) {
        await router.push(decodeURIComponent(localePath(promoUrl)));
        return
      }
      await router.push(decodeURIComponent(localePath(`/promo/${promoUrl}`)));
    }

    return {
      promoGetters,
      handleClick
    }
  }

})
